import React from "react";
import { Box, Chip, Tooltip, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { PROMO_COLORS } from "../constants/colors";
import { friendlyPromoWarning } from "../utils/promoWarningLabels";

export default function WarningBadges({ warnings = [], compact = false }) {
  if (!warnings.length) return null;

  const labels = warnings.map((w) => friendlyPromoWarning(w));

  if (compact) {
    const n = warnings.length;
    const tooltipBody = (
      <Box component="ul" sx={{ m: 0, pl: 2.25, maxWidth: 320 }}>
        {labels.map((text, i) => (
          <Typography
            key={`warn-tip-${i}`}
            component="li"
            variant="caption"
            sx={{ display: "list-item", mb: 0.35, fontSize: 12, lineHeight: 1.45 }}
          >
            {text}
          </Typography>
        ))}
      </Box>
    );

    return (
      <Tooltip title={tooltipBody} arrow placement="top" enterTouchDelay={0}>
        <Chip
          icon={<WarningAmberIcon sx={{ fontSize: "16px !important" }} />}
          label={`${n} warning${n === 1 ? "" : "s"}`}
          size="small"
          sx={{
            height: 26,
            maxWidth: "100%",
            backgroundColor: `${PROMO_COLORS.warning}18`,
            color: PROMO_COLORS.warning,
            fontWeight: 700,
            fontSize: 11,
            border: `1px solid ${PROMO_COLORS.warning}40`,
            cursor: "help",
            "& .MuiChip-icon": { color: PROMO_COLORS.warning },
            "& .MuiChip-label": { px: 0.5 },
          }}
        />
      </Tooltip>
    );
  }

  return (
    <Box display="flex" flexWrap="wrap" gap={0.5} mt={0.75}>
      {warnings.map((w, i) => (
        <Chip
          key={`promo-warn-${i}`}
          label={friendlyPromoWarning(w)}
          icon={<WarningAmberIcon sx={{ fontSize: "15px !important" }} />}
          size="small"
          sx={{
            height: 30,
            maxWidth: "100%",
            backgroundColor: "#fff8f0",
            color: PROMO_COLORS.warning,
            fontWeight: 500,
            fontSize: 14,
            lineHeight: 1.25,
            border: `1px solid ${PROMO_COLORS.warning}55`,
            "& .MuiChip-label": {
              px: 0.85,
              py: 0,
              fontSize: 12,
              whiteSpace: "normal",
              display: "block",
            },
            "& .MuiChip-icon": {
              color: PROMO_COLORS.warning,
              ml: 0.5,
              mr: -0.15,
              fontSize: "15px !important",
            },
          }}
        />
      ))}
    </Box>
  );
}
